import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Button, Col, Row } from "react-bootstrap";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import Small_chevron_right from "src/icons/Small-chevron-right";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import Content from "./Content";
import SectionHeading from "./SectionHeading";
import Translate from "./Translate";
import dynamic from "next/dynamic";

const LottieImage = dynamic(() => import("src/components/LottieImage"));

const EmptyBasket = () => {
  const { locale: lang, push } = useRouter();

  return (
    <Content fluid={`xl`} verticalSpace="lg">
      <div style={gutter("margin", "top", "md")}>
        <LottieImage src="Lottie-shopping-bag-empty" width={300} height={300} />
      </div>
      <SectionHeading
        align="center"
        subtitle="Don't hesitate to buy"
        style={gutter("margin", "top", "md")}
        title="Shopping cart is empty!"
      />
      <Row>
        <Col xs={12}>
          <div
            className={composeClassNames([
              sButtons,
              "row",
              "align-center",
              "buttons-404",
            ])}
          >
            <Button
              className={composeClassNames([sButton, "btn-icon-after"])}
              onClick={() => push(constants.Paths.landingPageMembersCta)}
              variant="outline-primary"
            >
              <Translate tKey="Subscription" />
              <Small_chevron_right />
            </Button>
            <Button
              className={composeClassNames([sButton])}
              onClick={() => push(constants.Paths.pageClasses)}
              variant="outline-secondary"
            >
              <Translate tKey="Series and classes" />
            </Button>
          </div>
        </Col>
      </Row>
    </Content>
  );
};

export default EmptyBasket;
